import { useMemo } from 'react'
import { Spinner, Row, Col } from "reactstrap"
import { useLocation, Link } from 'react-router-dom'
import { isEmpty } from '../../../utility/Utils'
import BlankLayout from '../../layouts/BlankLayout'
import '@styles/base/pages/page-auth.scss'

const SpinnerComponent = () => {
  const location = useLocation()
  const { search, pathname } = location
  function useQuery() {
    return useMemo(() => new URLSearchParams(search), [search])
  }
  const query = useQuery()
  const queryParam = query.get('parameter')

  return isEmpty(queryParam) || pathname?.split('/').pop() !== "add" ?
    (
      <div className='fallback-spinner vh-100'>
        {/* <img className='fallback-logo' src={logo} alt='logo' /> */}
        <div className='loading'>
          <div className='effect-1 effects'></div>
          <div className='effect-2 effects'></div>
          <div className='effect-3 effects'></div>
        </div>
      </div>
    ) : (
      <div className="fallback-spinner vh-100">
        <BlankLayout >
          <div className='auth-wrapper auth-v2'>
            <Row className='auth-inner m-0'>
              <Link className='brand-logo align-items-center' to='/'>
                <h2 className='brand-text text-primary ml-0 Gima-Medium'>Workflow</h2>
              </Link>
              <Col className='d-flex align-items-center p-5' lg='12' sm='12'>
                <div className='w-100 d-lg-flex align-items-center justify-content-center px-5'>
                  <Spinner type='grow' size='lg' color="primary" />
                </div>
              </Col>
            </Row>
          </div>
        </BlankLayout>
      </div>
    )
}

export default SpinnerComponent
